import React, { createContext } from "react";

export const DomestikaContext = createContext();

/* eslint-disable-next-line react/prop-types */
export const DomestikaProvider = ({ children, value }) => (
  <DomestikaContext.Provider value={value}>{children}</DomestikaContext.Provider>
);
